import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import AuthSlice from 'features/Auth/Slices/auth';

interface Props extends RouteProps {
	component: Exclude<RouteProps['component'], undefined>;
	title: string;
}

const AuthorizedRoute: React.FC<Props> = ({ title, component, ...rest }) => {
	const { keycloak } = useKeycloak();
	const dispatch = useDispatch();
	const Component = component;

	return (
		<Route
			{...rest}
			render={(props) => {
				if (keycloak.authenticated) {
					dispatch(AuthSlice.actions.SET_TITLE(title));
					return <Component {...props} />;
				}
				return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
			}}
		/>
	);
};

export default AuthorizedRoute;
